import { Facebook, Instagram, Music2, MapPin, Truck, Store, MessageCircle } from "lucide-react";

const socials = [
  { name: "Facebook", href: "https://www.facebook.com/groups/1112257584339430", icon: Facebook, testid: "social-facebook-link", placeholder: false },
  { name: "Instagram", href: "https://www.instagram.com/canadianbeatsmarketplace/", icon: Instagram, testid: "social-instagram-link", placeholder: false },
  { name: "TikTok", href: "https://www.tiktok.com/@canadianbeatsmarketplace", icon: Music2, testid: "social-tiktok-link", placeholder: false },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] py-20 text-white sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <h2 className="font-display text-5xl font-black uppercase leading-[0.9] tracking-tighter sm:text-7xl lg:text-8xl">
          Canadian
          <br />
          <span className="text-[#FF2A54]">Beats</span> <span className="text-[#FFD700]">Marketplace</span>
        </h2>
        <p className="mt-6 max-w-md text-base text-white/70">
          Stop in, taste life: trends, fun, and treats. Marketing happens on Facebook — ordering happens right here.
        </p>

        <div className="mt-10 flex flex-wrap gap-4">
          {socials.map((s) => (
            <a
              key={s.name}
              href={s.href}
              target={s.placeholder ? undefined : "_blank"}
              rel="noopener noreferrer"
              aria-label={`${s.name}${s.placeholder ? " (coming soon)" : ""}`}
              data-testid={s.testid}
              className="hard-shadow-hover flex items-center gap-2 rounded-full border-2 border-white/30 px-5 py-2.5 font-display text-sm font-extrabold uppercase tracking-wide text-white transition-colors hover:border-[#FFD700] hover:text-[#FFD700]"
            >
              <s.icon className="h-4 w-4" /> {s.name}
              {s.placeholder && <span className="text-[10px] normal-case text-white/50">soon</span>}
            </a>
          ))}
        </div>

        <ul data-testid="footer-info" className="mt-12 grid grid-cols-1 gap-3 border-t-2 border-white/15 pt-8 text-sm font-medium text-white/80 sm:grid-cols-2 lg:grid-cols-4">
          <li className="flex items-center gap-2.5" data-testid="footer-local-pickup">
            <Store className="h-4 w-4 shrink-0 text-[#FFD700]" /> Local Pickup Available
          </li>
          <li className="flex items-center gap-2.5" data-testid="footer-ships-canada">
            <Truck className="h-4 w-4 shrink-0 text-[#FFD700]" /> Ships Across Canada
          </li>
          <li className="flex items-center gap-2.5" data-testid="footer-location">
            <MapPin className="h-4 w-4 shrink-0 text-[#FFD700]" /> Meteghan River, Nova Scotia
          </li>
          <li className="flex items-center gap-2.5" data-testid="footer-contact">
            <MessageCircle className="h-4 w-4 shrink-0 text-[#FFD700]" />
            <a href="https://www.facebook.com/groups/1112257584339430" target="_blank" rel="noopener noreferrer"
              className="underline decoration-[#FFD700] decoration-2 underline-offset-4 hover:text-[#FFD700]">
              Questions? Message us on Facebook
            </a>
          </li>
        </ul>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-4 border-t-2 border-white/15 pt-8 text-xs text-white/50">
          <span>&copy; {new Date().getFullYear()} Canadian Beats Marketplace. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
